import styles from './O_HeaderBurgerMenu.module.css';
import { Link, useNavigate } from 'react-router-dom';
import { PATHS } from '@/constants/paths';
import A_Logo from '@/components/A_Atoms/A_Logo/A_Logo';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import { getTranslation } from '@/constants/translations';
import { useLanguage } from '@/contexts/LanguageContext';
import A_HeaderItem from '@/components/A_Atoms/A_HeaderItem/A_HeaderItem';
import A_UserAvatar from '@/components/A_Atoms/A_UserAvatar/A_UserAvatar';
import cn from 'classnames';

interface O_HeaderBurgerMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function O_HeaderBurgerMenu({
  isOpen,
  onClose,
}: O_HeaderBurgerMenuProps) {
  const { language } = useLanguage();
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.sheet} onClick={e => e.stopPropagation()}>
        <div className={styles.handle} />
        <div className={styles.content}>
          <div className={styles.menu_wrapper}>
            <h4 className={styles.header}>
              {getTranslation(language, 'header.menu')}
            </h4>
            <A_Button
              variant='primary'
              icon={
                <Q_Icon.StarIcon
                  width={24}
                  height={24}
                  fill='white'
                  stroke='white'
                />
              }
              fontSize='text-p-4'
              showIcon={true}
              size='small'
              width='100%'
              onClick={() => {
                navigate(PATHS.CAPSULE_CREATE);
                onClose();
              }}
            >
              {getTranslation(language, 'header.create')}
            </A_Button>
            <Link to={PATHS.HOME} className={styles.row} onClick={onClose}>
              <A_Logo variant='withLabel' />
            </Link>
            <A_HeaderItem
              icon={<Q_Icon.ChatIcon width={24} height={24} fill='none' />}
              label={getTranslation(language, 'header.chat')}
              to={PATHS.CHAT}
              ariaLabel={getTranslation(language, 'header.chat')}
            />
            <A_HeaderItem
              icon={<Q_Icon.CapsIcon width={24} height={24} fill='none' />}
              label={getTranslation(language, 'header.capsules')}
              to={PATHS.CAPSULES}
              ariaLabel={getTranslation(language, 'header.capsules')}
            />
            <A_HeaderItem
              icon={
                <Q_Icon.NotificationsIcon width={24} height={24} fill='none' />
              }
              label={getTranslation(language, 'header.notifications')}
              to={PATHS.PROFILE_WITH_TAB('notifications')}
              ariaLabel={getTranslation(language, 'header.notifications')}
            />
            <Link to={PATHS.PROFILE} className={styles.row} onClick={onClose}>
              <A_UserAvatar />
              <span className={cn('text-p-2', styles.profile_text)}>
                {getTranslation(language, 'header.profile')}
              </span>
            </Link>
          </div>
          <div className={styles.menu_wrapper}>
            <Link
              to={PATHS.ABOUT}
              className={cn(styles.link, 'text-p-2')}
              onClick={onClose}
            >
              {getTranslation(language, 'header.about')}
            </Link>
            <Link
              to={PATHS.FAQ}
              className={cn(styles.link, 'text-p-2')}
              onClick={onClose}
            >
              {getTranslation(language, 'header.faq')}
            </Link>
          </div>
          <div className={styles.links_wrapper}>
            <Link
              to={'/privacy-policy'}
              className={cn(styles.link_small, 'text-caption')}
              onClick={onClose}
            >
              {getTranslation(language, 'footer.links.privacyPolicy')}
            </Link>
            <Link
              to={'/terms-of-use'}
              className={cn(styles.link_small, 'text-caption')}
              onClick={onClose}
            >
              {getTranslation(language, 'footer.links.termsOfUse')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
